import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    todayStatistics: null,
    yesterdayStatistics: null,
    lastWeekStatistics: null,
    customStatistics: null,
    customForHereStatistics: null,
    storeHotSale: null,
    startDate: null,
    endDate: null,
    variation: null,
    searchUnit: 'month',
    storeHotSaleReport: []
  },
  getters: {
    storeHotSaleReport: state => {
      if (state.storeHotSaleReport) {
        const result = [...state.storeHotSaleReport]
        return result.sort((a, b) => a.index - b.index)
      } else {
        return null
      }
    }
  },
  mutations,
  actions
}
